import jwtDecode from 'jwt-decode'
import { VERIFY_TOKEN } from '../../actionTypes'
import { logOut } from './logOut'
import { hideLoader } from './../loader/hideLoader'
import { setAlert } from './../alert/setAlert'
export const verifyToken = () => (dispatch) => {
  dispatch({ type: VERIFY_TOKEN })
  const token = JSON.parse(localStorage.getItem('token'))
  if (token === null) {
    dispatch(logOut())
  }
  if (token) {
    const isExpired = jwtDecode(token)
    if (isExpired.exp * 1000 < new Date().getTime()) {
      dispatch(hideLoader())
      dispatch(logOut())
      dispatch(
        setAlert(true, 'error', 'Session expired, please, log in again', 2000)
      )
    }
  }
}
